export function productsStepConfig({ country, currentDate, type = 'KCO_ONE' }) {
  const products = {
    KCO_ONE: [
      {
        id: 'kco_one',
        options: [
          { id: 'kco_one-pay-now' },
          { id: 'kco_one-pay-later' },
          { id: 'kco_one-slice-it' },
          { id: 'kco_one-address-widget' },
        ],
        tocLink: 'https://link-to-klarna-cdn.com',
        tocTimestamp: currentDate,
        status: 'AWAITING_APPROVAL',
      },
    ],
    KP_ONE: [
      {
        id: 'kp_one',
        options: [{ id: `kp_one-slice-it-in-${country === 'US' ? '4' : '3'}` }],
        tocLink: 'link',
        tocTimestamp: currentDate,
        status: 'AWAITING_APPROVAL',
      },
    ],
    KCO: [
      {
        id: 'kco',
        options: [
          { id: 'kco-pay-now' },
          { id: 'kco-pay-later' },
          { id: 'kco-slice-it' },
          { id: 'kco-address-widget' },
        ],
        tocLink: 'https://link-to-klarna-cdn.com',
        tocTimestamp: currentDate,
        status: 'AWAITING_APPROVAL',
      },
    ],
    KP: [
      {
        id: 'kp',
        options: [
          {
            id: `kp-slice-it-in-${country === 'US' ? '4' : '3'}`,
            tocLink: 'link',
            tocTimestamp: currentDate,
            status: 'AWAITING_APPROVAL',
          },
        ],
      },
    ],
  };

  return {
    products: {
      value: products[type],
      method: 'applyProperty',
      path: 'products',
    },
  };
}
